module.exports = __webpack_public_path__ + "img/icon3.fbc27ac8.jpg";